export default "__VITE_ASSET__Dul$1SJR__"